'use client'

import { Toaster } from '@kiao-voice/ui-kit'
import { useTranslation } from 'react-i18next'

/**
 * The only toast host in the web app (mounted once in the root layout). Every
 * toast, whether it comes from `toast.*` or `useToast()`, is drawn here.
 */
export function AppToaster() {
  const { t } = useTranslation('web')
  return <Toaster dismissLabel={t('common.toastDismiss')} regionLabel={t('common.toastRegion')} />
}
